import React, { useState, useContext, Fragment, useEffect } from "react";

import address from "../img/address.svg";
import calendar from "../img/calendar.svg";
import ticketSeparator from "../img/job-details-separator.svg";
import brokeChainIcon from "../img/broke-chain-icon.svg";
import creditCardIcon from "../img/creditcard-icon.svg";

import CircularProgress from "@mui/material/CircularProgress";
import Popover from "@mui/material/Popover";
import { styled } from "@mui/material/styles";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useNotification } from '../context/NotificationContext';

import { createErrorMessage } from "../utils/index";

import {
  copyToClipBoard,
  validatePositiveInteger,
  validatePositiveFloat,
} from "../utils";

import { useLazyGetUserFromApiQuery } from '../services/accountsApi';
import { useLazyGetBuyngEmailPrivateFromApiQuery, useLazyGetCreditCardViewsQuery, useLazyGetBuyingEmailsFromApiQuery, useLazyGetCreditsCardsFromApiQuery, useGetMyCreditCardsQuery} from '../services/creditCards';
import { useCreatePurchaseMutation, useLazyGetDeliveryMethodsFromApiQuery } from '../services/purchaseApi';

import EscalationModal from "./escalationModal";
import AppContext from "../context/AppProvider";
import checkOn from "../img/done-icon.svg";
import checkOff from "../img/close-icon.svg";
import { Button, Divider, IconButton, Select, MenuItem, TextField } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { eventDatesFormatter } from "../utils/dates";
import { parseToEasternTime } from './../utils/dates';
import BuyingEmailForm from "../screens/adminToolsTabs/components/BuyingEmailForm";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../features/auth/authSlice.js";
import { useGetPlatformNamesQuery, useLazyGetPlatformsForUserQuery } from "../services/platformsApi.js";
import SpecialInstructionModal from "./modals/SpecialnstructionModal";
import UserDecryptCreditCardPopover from "./creditCards/UserDecryptCreditCardPopover.jsx";
const style = {
  position: "absolute",
  width: '100%',
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: 'flex', justifyContent: 'center', alignItems: 'center'
};

function isBlank(str) {
  return !str || /^\s*$/.test(str);
}

const requiredFields = [
  "buyingEmailId",
  "creditCardId",
  "platformCredentialId",
  // "purchaseURL",
  "quantity",
  "purchaseTotal",
  "deliveryMethodID",
  "section",
  "row",
  "seats",
  "orderNumber",
];

export default function JobDetails(props) {

  const { showNotification } = useNotification();

  const [initGetUserFromApi, {isLoading: getUserFromApiIsLoading}] = useLazyGetUserFromApiQuery();
  const [initCreatePurchase, {isLoading: createPurchaseIsLoading}] = useCreatePurchaseMutation();
  const [initGetBuyngEmailPrivateFromApi, {isLoading: getBuyngEmailPrivateFromApiIsLoading}] = useLazyGetBuyngEmailPrivateFromApiQuery();
  const [initGetCreditCardViews, {isLoading: getCreditCardViewsIsLoading}] = useLazyGetCreditCardViewsQuery();
  const [initGetBuyingEmailsFromApi, {isLoading: getBuyingEmailsFromApiIsLoading}] = useLazyGetBuyingEmailsFromApiQuery();
  const [initGetCreditsCardsFromApi, {isLoading: getCreditsCardsFromApiIsLoading}] = useLazyGetCreditsCardsFromApiQuery();
  const [initGetDeliveryMethodsFromApi, {isLoading: getDeliveryMethodsFromApiIsLoading}] = useLazyGetDeliveryMethodsFromApiQuery();
  const {data: creditCards, isLoading: creditCardsIsLoading} = useGetMyCreditCardsQuery({isDeleted: false, isActive: true});

  const [getUsersPlatformsCredentials, { data: allCredentialsForUser }] = useLazyGetPlatformsForUserQuery();
  const {data: platforms } = useGetPlatformNamesQuery();
  const [open, setOpen] = useState(false);
  const [buyingEmails, setbuyingEmails] = useState([]);
  const [deliveryMethods, setDeliveryMethods] = useState([]);
  const [emailPassword, setEmailPassword] = useState(null);
  const [showRF, setShowRF] = useState(false); //RF: required fields
  const [showEmail, setShowEmail] = useState(false);
  const [showCopy, setShowCopy] = useState(false);
  const [showPlatformCopy, setShowPlatformCopy] = useState(false);
  const [openAddEmailModal, setOpenAddEmailModal] = useState(null);
  const [specialInstructionModalOpen, setSpecialInstructionModalOpen] = useState(false);
  const [isLoadingEscalation, setIsLoadingEscalation] = useState(false)
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  const [isLoading, setIsLoading] = useState(false); //A: flag , if true the app is sending a http request to backend.

  let [snackBarProp, setSnackBarProp] = useState({
    status: null,
    text: "",
    snackBarOpenProp: false,
  });

  const [formPurchase, setFormPurchase] = useState({});

  const { currentJob, fetchingCurrentJob } = useContext(AppContext);
  const user = useSelector(selectCurrentUser);

  useEffect(async () => {
    if (user && user.id) {
      getUsersPlatformsCredentials(user.id);
    }
  }, [user])

  function GetCredentialsOptions() {
    if (!formPurchase.buyingEmailId) return null;
    let activeCredentials = allCredentialsForUser?.filter(cred => !cred.isDeleted && parseInt(cred.buyingEmailId) == parseInt(formPurchase.buyingEmailId));
    console.log("activeCredentials: " + JSON.stringify(activeCredentials));
    if (!activeCredentials || activeCredentials.length == 0) return null;

    function getPlatformName(platformId) {
      let aux = platforms || [];
      let platform = aux.find(p => p.id == platformId);
      return platform?.name || platformId;
    }

    function getShortName(ac) {
      let aux = platforms || [];
      let platform = aux.find(p => p.id == ac.platformId);
      if (platform?.name == "TM/LN") return "";
      return " - " + ac?.shortName || "";
    }

    return activeCredentials.map((ac, idx) => (
      <MenuItem value={ac.id} key={idx}>{`${getPlatformName(ac.platformId)} - ${ac.platformPassword} ${getShortName(ac)}`} </MenuItem>
    ))
  }

  useEffect(() => {
    if (currentJob && currentJob.id && !isBlank(currentJob.specialInstructions)) {
      setSpecialInstructionModalOpen(true)
    }
  }, [currentJob])


  // ------------------ validations ---------------------

  const [validation, setValidation] = useState({});

  var objectNotation = {};

  useEffect(() => {
    //validate Total spend only money value without dollar sign

    if (isBlank(formPurchase.purchaseTotal)) {
      objectNotation.purchaseTotal = true;
    } else {
      objectNotation.purchaseTotal = false;
    }

    if (validatePositiveFloat(formPurchase.purchaseTotal)) {
      objectNotation.purchaseTotal = false;
    } else {
      objectNotation.purchaseTotal = true;
    }
    setValidation({ ...objectNotation });
  }, [formPurchase]);

  useEffect(() => {
    // validate quantity (it's already a number input type)

    setTimeout(() => {
      if (validatePositiveInteger(formPurchase.quantity)) {
        objectNotation.quantity = false;
      } else {
        objectNotation.quantity = true;
      }

      setValidation({ ...objectNotation });
    }, 100);

    clearTimeout();
  }, [formPurchase]);

  // ------------------ validations ---------------------

  useEffect(() => {
    async function getBuyingEmails() {
      if (!user.id) return;
      let promises = [];
      promises.push(
        initGetBuyingEmailsFromApi(
          `?assignedUserId=${user.id}&isActive=true&isDeleted=false`
        ).unwrap()
      );
      promises.push(initGetDeliveryMethodsFromApi().unwrap());

      Promise.all(promises).then((values) => {
        setbuyingEmails(values[0].data);
        let deliveryMethodsRes = values[1];
        setDeliveryMethods(deliveryMethodsRes); // set the delivery methods
      });
    }
    getBuyingEmails();
  }, [user]);

  useEffect(async () => {
    if (showEmail) {
      try {
        console.log("REQUESTING PASSWORD");
        let id = formPurchase.buyingEmailId;
        console.log("REQUEST ID: ", id);
        let { data } = await initGetBuyngEmailPrivateFromApi(id).unwrap();
        console.log(data.mailboxPassword);
        if (data.mailboxPassword) {
          setEmailPassword(data.mailboxPassword);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, [showEmail]);

  function showRed(field) {
    if (!requiredFields.includes(field)) return; //A: is not a required field
    if ((!formPurchase[field] && showRF) || (validation[field] && showRF))
      return "1px solid red";
  }

  async function handleSubmit() {
    let errorInForm = false;
    requiredFields.every((field) => {
      if (!formPurchase[field] || isBlank(formPurchase[field])) {
        console.log("field: " + field + " is not in form");
        setShowRF(true);
        showNotification('Complete required Fields', 'error');
        errorInForm = true;
        return false;
      }
      return true;
    });
    if (errorInForm) return;
    try {
      setIsLoading(true);
      console.log("SUBMIT: ", formPurchase);
      let obj = {
        ...formPurchase,
        purchaseTotal: Math.floor(formPurchase.purchaseTotal * 100),
        requestID: currentJob.id,
        requestTypeID: 1, //TODO: get id from server
      }

      console.log("OBJ: ", obj);

      let res = await initCreatePurchase(obj).unwrap();
      console.log(res);
      if (res.status === "Ok" && res.status != "Failed") {
        showNotification('Saved!','success');
        setIsLoading(false);
        window.location.href = "/dashboard/jobs";
      } else {
        console.log("error creating purchase: ", res);
        setIsLoading(false);
        showNotification(createErrorMessage(res), 'error');
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      showNotification(createErrorMessage(err), 'error');
    }
  }

  function handleQuantity(e) {
    const result = e.target.value.replace(/[^0-9]/gi, "");
    setFormPurchase({
      ...formPurchase,
      quantity: result,
    });
  }

  function getBuyingEmailById(buyingEmailId) {
    if (buyingEmailId == null || buyingEmailId == '') return '';
    if (buyingEmails == null) return '';
    const found = buyingEmails.find(buyingEmail => buyingEmail.id == buyingEmailId);
    if (found == undefined || found == null) return '';
    return found.emailAddress;
  }

  function buyingEmailCreationOnSuccess(apiRes) {
    if (apiRes.buyingEmail.isActive == false) { }
    const updatedBuyingEmails = [...buyingEmails];

    const index = updatedBuyingEmails.findIndex((email) => email.id === apiRes.buyingEmail.id);
    if (index !== -1 && apiRes.buyingEmail.isActive == false) { //A: deleteded from local storage because is no loger active.
      updatedBuyingEmails.splice(index, 1);
      if (formPurchase.buyingEmailId == apiRes.buyingEmail.id) { //A: if the deleted email is the one selected, reset the form.
        setFormPurchase({
          ...formPurchase,
          platformCredentialId: "",
          buyingEmailId: null,
        });
      }
    }
    else if (index !== -1) {
      updatedBuyingEmails[index] = apiRes.buyingEmail;
    } else {
      updatedBuyingEmails.push(apiRes.buyingEmail);
    }

    setbuyingEmails(updatedBuyingEmails);
    getUsersPlatformsCredentials(user.id); //A: request platform credentials again.
    //A: added new buying email to local state.
  }

  return (
    <div>
      <h3 style={{ color: "var(--orange)", margin: "0 0 1em 0" }}>
        Current Job
      </h3>

      {fetchingCurrentJob && <CircularProgress sx={{ color: "#F29B1B" }} />}

      {!fetchingCurrentJob && currentJob && (
        <Fragment>
          <div className="orange-container">
            <div className="job-container">
              <div className="job-details-top">
                {/* -------------------------------------- */}

                <div className="id-date">

                  <p className="job-card-id" style={{ color: "var(--grey-inactive)" }} >
                    ID: {currentJob.id}
                  </p>

                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <p className="job-card-id " style={{ color: "var(--grey-inactive)" }} >
                      Job started date
                    </p>
                    <p className="job-card-id" style={{ margin: "0 0 0 0.5em" }} >
                      {parseToEasternTime(currentJob.currentOwnerStarted)}
                    </p>
                  </div>
                </div>
                {/* -------------------------------------- */}
                <div className="top-info">
                  <div className=" job-card-description">
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', margin: '0 0 0.25em 0' }} >
                      <a href={currentJob.primaryUrl} target="_blank" rel="noreferrer" style={{ display: 'flex' }} >
                        <h4 className="job-card-description-title">
                          {currentJob.name}
                        </h4>
                      </a>

                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <a href={currentJob.primaryUrl} target="_blank" rel="noreferrer" style={{ display: 'flex' }} >
                          <OpenInNewOutlinedIcon color="primary" />
                        </a>
                        <IconButton
                          style={{ display: 'flex' }}
                          color="primary"
                          sx={{ margin: '0 0.25em 0 0', padding: '0 8px' }}
                          onClick={() => copyToClipBoard(currentJob.primaryUrl || currentJob.primaryEventUrl)}>
                          <ContentCopyIcon />
                        </IconButton>
                      </div>
                    </div>
                    <div className="job-card-description-content">
                      <img
                        src={calendar}
                        alt="Calendar Icon"
                        style={{ margin: "0 0.5em 0 0" }}
                      />
                      <p className="job-card-description-text">
                        {eventDatesFormatter(currentJob.date)}
                      </p>
                    </div>
                    <div className="job-card-description-content">
                      <img
                        src={address}
                        alt="Location Icon"
                        style={{ margin: "0 0.5em 0 0" }}
                      />
                      <p className="job-card-description-text">
                        {" "}
                        {currentJob.venue.name} ( {currentJob.venue.city},{" "}
                        {currentJob.venue.state} )
                      </p>
                    </div>
                  </div>

                  <div className=" job-card-actions ">
                    <button className="job-card-actions-button-reward" disabled>
                      ${currentJob.rewardAmt}
                      {/* {currentJob.rewardType} commented on ticket BEE-611 */}
                    </button>
                  </div>

                </div>
                {/* -------------------------------------- */}

                <div className="divider" ></div>

                {/* -------------------------------------- */}

                <div className="job-card-information">

                  <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", gap: "0.5em" }}>
                    <p
                      style={{
                        color: "var(--orange)",
                        fontWeight: "700",
                        margin: "0 0.5em 0 0",
                      }}
                    >
                      Quantity:
                    </p>
                    <p style={{ fontWeight: "700" }}>{currentJob.quantity}</p>
                  </div>

                  <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", gap: "0.5em" }}>
                    <p
                      style={{
                        color: "var(--orange)",
                        fontWeight: "700",
                        margin: "0 0.5em 0 0",
                      }}
                    >
                      Section:
                    </p>
                    <p style={{ fontWeight: "700" }}>{currentJob.section}</p>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", gap: "0.5em" }}>
                    <p
                      style={{
                        color: "var(--orange)",
                        fontWeight: "700",
                        margin: "0 0.5em 0 0",
                      }}
                    >
                      Row:
                    </p>
                    <p style={{ fontWeight: "700" }}>{currentJob.row}</p>
                  </div>

                  <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", gap: "0.5em" }}>
                    <p
                      style={{
                        color: "var(--orange)",
                        fontWeight: "700",
                      }}
                    >
                      Cost Per Ticket:
                    </p>
                    <p style={{ fontWeight: "700" }}>
                      ${currentJob.perTicketOTDEst}
                    </p>
                  </div>

                  <div className="instructions-checkbox">
                    <img
                      src={currentJob.includesFees ? checkOn : checkOff}
                      alt="ok icon"
                      height="24px"
                      style={{ margin: "0 0.25em 0 0" }}
                    />

                    <p
                      style={{ color: "var(--orange)", fontWeight: "700" }}
                      htmlFor="newBee"
                    >
                      {currentJob.includesFees ? "Cost Includes Fees" : "Cost doesn’t Include Fees"}
                    </p>
                  </div>

                  <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", gap: "0.5em" }}>
                    <p
                      style={{
                        color: "var(--orange)",
                        fontWeight: "700",
                        margin: "0 0.5em 0 0",
                      }}
                    >
                      Code to Use:
                    </p>
                    <p style={{ fontWeight: "700" }}>{currentJob.codeToUse || "-"}</p>
                  </div>


                </div>
                {/* -------------------------------------- */}

                <div className="divider" ></div>

                {/* -------------------------------------- */}

                <div className="special-instructions">
                  <h4 style={{ color: "var(--orange)", fontWeight: "600", margin: '0 0 0.25em 0' }}>
                    Special Instructions
                  </h4>
                  <p style={{ font: "var(--p2)" }}>
                    {currentJob.specialInstructions}
                  </p>
                </div>
              </div>

              {/* ------------------------------------------------------------------------------ */}

              <div style={{ height: " auto ", display: "flex" }}>
                <img src={ticketSeparator} alt="ticket cut line" width="100%" />
              </div>

              {/* ------------------------------------------------------------------------------ */}

              <div style={{ backgroundColor: "white", padding: "0 16px 16px 16px", borderRadius: "0 0 1.5em 1.5em" }}>
                <div className="buy-details-title">
                  <h3 style={{ margin: "0" }}>Add Buy Details</h3>
                </div>

                <div className="bottom-inputs">

                  <div className="add-buy-details-top">
                    <div style={{ display: "flex", flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                      <label>Buying Email Used</label>

                      <IconButton
                        sx={{ height: '28px', width: '28px', margin: '0 0.25em 0 0' }}
                        color="primary"
                        variant="contained"
                        style={{ margin: '0 0 4px 4px' }}
                        onClick={() => {
                          copyToClipBoard(getBuyingEmailById(formPurchase.buyingEmailId))
                          setShowCopy(true)
                        }}
                      >
                        <ContentCopyIcon
                          sx={{ height: '20px' }}
                          id="EmailCopylAnchor"
                        />
                      </IconButton>

                      <IconButton
                        sx={{ height: '28px', width: '28px' }}
                        style={{ margin: '0 0 4px 0' }}
                        color="primary"
                        variant="contained"
                        onClick={() => {
                          setOpenAddEmailModal({
                            userId: user.id,
                            title: `${user.firstName + " " + (user.lastName || "")} Buying Email details`
                          })
                        }}
                      >
                        <AddOutlinedIcon sx={{ height: '20px' }} />
                      </IconButton>
                      <Popover
                        id="EmailCopylAnchor"
                        open={showCopy}
                        anchorEl={document.getElementById("EmailCopylAnchor")}
                        onClose={() => setShowCopy(false)}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      >
                        <p style={{ margin: "0", padding: "0.5em", fontSize: "0.85rem" }} >
                          {formPurchase.buyingEmailId ? (
                            <span style={{ fontWeight: 700, color: 'var(--orange)' }}>
                              Copied!
                            </span>
                          ) : (
                            <span>Please select a Buying Email.</span>
                          )}
                        </p>
                      </Popover>

                    </div>

                    <Select
                      value={formPurchase.buyingEmailId}
                      defaultValue={"default"}
                      name="emailAccountUsed"
                      style={{ width: "100%", height: "32px", padding: "0 4px", border: showRed("buyingEmailId"), }}
                      sx={{ "& .MuiSelect-select": { padding: "0.5em" } }}
                      onChange={(e) => {
                        setFormPurchase({
                          ...formPurchase,
                          platformCredentialId: "", // reset password
                          buyingEmailId: e.target.value,
                        });
                      }}
                    >
                      {/* {!formPurchase.buyingEmailId && (
                          <option key={"default"} value>
                            {" "}
                            -- select an option --{" "}
                          </option>
                        )} */}
                      {buyingEmails.map(({ id, emailAddress }) => (
                        <MenuItem value={id} key={id}>
                          {emailAddress}
                        </MenuItem>
                      ))}
                    </Select>

                  </div>

                  {/* -------------------------------------------- */}

                  <div className="add-buy-details-top">

                    <div style={{ display: "flex", flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                      <label >Box Office Password Used</label>
                      <IconButton
                        sx={{ height: '28px', width: '28px' }}
                        color="primary"
                        variant="contained"
                        style={{ margin: '0 0 4px 4px' }}
                        onClick={() => {
                          copyToClipBoard(allCredentialsForUser.find(cred => cred.id == formPurchase.platformCredentialId)?.platformPassword || "")
                          setShowPlatformCopy(true)
                        }}
                      >
                        <ContentCopyIcon
                          sx={{ height: '20px' }}
                          id="platformCredentialAnchor"
                        />
                      </IconButton>


                      <IconButton
                        sx={{ height: '28px', width: '28px' }}
                        color="primary"
                        variant="contained"
                        style={{ margin: '0 0 4px 0' }}
                        disabled={!formPurchase.buyingEmailId}
                        onClick={() => {
                          setOpenAddEmailModal({
                            emailId: formPurchase.buyingEmailId,
                            userId: user.id,
                            title: `${user.firstName + " " + (user.lastName || "")} Buying Email details`,
                          })
                        }}
                      >
                        <EditOutlinedIcon sx={{ height: '20px' }} />
                      </IconButton>

                      <Popover
                        id="platformCredentialAnchor"
                        open={showPlatformCopy}
                        anchorEl={document.getElementById("platformCredentialAnchor")}
                        onClose={() => setShowPlatformCopy(false)}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      >
                        <p style={{ margin: "0", padding: "0.5em", fontSize: "0.85rem" }} >
                          {formPurchase.platformCredentialId ? (
                            <span style={{ fontWeight: 700, color: 'var(--orange)' }}>
                              Copied!
                            </span>
                          ) : (
                            <span>Please select a Box Office Password.</span>
                          )}
                        </p>
                      </Popover>

                    </div>

                    <Select
                      value={formPurchase.platformCredentialId}
                      name="emailAccountUsed"
                      style={{ width: "100%", height: "32px", padding: "0 4px", border: showRed("platformCredentialId") }}
                      sx={{ "& .MuiSelect-select": { padding: "0.5em" } }}
                      onChange={(e) =>
                        setFormPurchase({
                          ...formPurchase,
                          platformCredentialId: e.target.value,
                        })
                      }
                    >
                      {/* {!formPurchase.platformCredentialId && (
                          <option key={"default"} value>
                            {" "}
                            -- select an option --{" "}
                          </option>
                        )} */}

                      {GetCredentialsOptions()}
                    </Select>



                  </div>

                  {/* -------------------------------------------- */}

                  <div className="add-buy-details-top">
                    <div style={{ display: "flex", alignItems: 'center', width: '100%' }}>
                      <label>Credit Card Used</label>
                      <UserDecryptCreditCardPopover creditCardId={formPurchase.creditCardId} />
                    </div>

                    <Select
                      value={formPurchase.creditCardId || ""}
                      defaultValue={"default"}
                      name="creditCardUsed"
                      style={{ width: "100%", height: "32px", padding: "0 4px", border: showRed("creditCardId"), }}
                      sx={{ "& .MuiSelect-select": { padding: "0.5em" } }}
                      onChange={(e) =>
                        setFormPurchase({
                          ...formPurchase,
                          creditCardId: e.target.value,
                        })
                      }
                    >
                      {/* {!formPurchase.creditCardId && (
                          <option key={"default"} value>
                            {" "}
                            -- select an option --{" "}
                          </option>
                        )} */}
                      {(creditCards || []).map((cc) => (
                        <MenuItem key={cc.id} value={cc.id}>
                          {`${cc.cardTypeName} XXXX-${cc.last4Digits} ${cc.expirMonth}/${cc.expirYear}`}
                        </MenuItem>
                      ))}
                    </Select>

                  </div>

                </div>

                {/* ----------------------------------------------------------------------------------- */}

                <div className="divider" />

                {/* -------------------------------------------- */}

                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", padding: "0 0 0.5em 0", justifyContent: 'center' }}>
                  <div style={{ maxWidth: '120px' }}>
                    <label>Quantity</label>
                    <TextField
                      step="1"
                      name="quantityPurchashed"
                      value={formPurchase.quantity}
                      style={{ border: showRed("quantity") }}
                      onChange={(e) => handleQuantity(e)}
                    />
                  </div>

                  <div style={{ maxWidth: '120px' }}>
                    <label>Section</label>
                    <TextField
                      name="sectionPurchashed"
                      value={formPurchase.section}
                      style={{ border: showRed("section") }}
                      onChange={(e) =>
                        setFormPurchase({
                          ...formPurchase,
                          section: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div style={{ maxWidth: '120px' }}>
                    <label>Row</label>
                    <TextField
                      name="rowPurchashed"
                      value={formPurchase.row}
                      style={{ border: showRed("row") }}
                      onChange={(e) =>
                        setFormPurchase({
                          ...formPurchase,
                          row: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div style={{ maxWidth: '120px' }}>
                    <label>Seat Numbers</label>
                    <TextField
                      name="seatsPurchashed"
                      value={formPurchase.seats}
                      style={{ border: showRed("seats") }}
                      onChange={(e) =>
                        setFormPurchase({
                          ...formPurchase,
                          seats: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div style={{ maxWidth: '120px' }}>
                    <label>Delivery Method</label>
                    <Select
                      id="delivery-method"
                      name="Delivery Method"
                      value={formPurchase.deliveryMethodID}
                      defaultValue={"default"}
                      style={{ border: showRed("deliveryMethodID"), width: '120px', height: '40px' }}
                      onChange={(e) =>
                        setFormPurchase({
                          ...formPurchase,
                          deliveryMethodID: e.target.value,
                        })
                      }
                    >
                      {/* {!formPurchase.deliveryMethodID && (
                        <option key={"default"} value>
                          {" "}
                          -- select an option --{" "}
                        </option>
                      )} */}

                      {deliveryMethods.map(({ name, id }) => (
                        <MenuItem value={id} key={id} >{name}</MenuItem>
                      ))}
                    </Select>
                  </div>

                  <div style={{ maxWidth: '120px' }}>
                    <label>Total Spend</label>
                    <TextField
                      type="number"
                      name="totalSpend"
                      placeholder="$"
                      value={formPurchase.purchaseTotal}
                      style={{ border: showRed("purchaseTotal") }}
                      InputProps={{
                        style: { height: "40px" }
                      }}
                      onChange={(e) =>
                        setFormPurchase({
                          ...formPurchase,
                          purchaseTotal: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div style={{ maxWidth: '120px' }}>
                    <label>Order Number</label>
                    <TextField
                      name="orderNumber"
                      required
                      value={formPurchase.orderNumber}
                      style={{ border: showRed("orderNumber") }}
                      onChange={(e) =>
                        setFormPurchase({
                          ...formPurchase,
                          orderNumber: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div style={{ maxWidth: '120px' }}>
                    <label>Code Used (OPT)</label>
                    <TextField
                      name="codeUsed"
                      style={{ border: showRed("codeUsed") }}
                      value={formPurchase.codeUsed}
                      onChange={(e) =>
                        setFormPurchase({
                          ...formPurchase,
                          codeUsed: e.target.value,
                        })
                      }
                    />

                  </div>

                </div>

                {/* /*-------------------------------------------------------------------------------------------------------*/}

                <div style={{ display:'flex', justifyContent:"center", flexWrap:"wrap" }} >
                  <Button
                    variant="contained"
                    disabled={isLoading || isLoadingEscalation}
                    sx={{
                      margin: { xs: "0.5em", md: "0 2px" },
                      width: { xs:"100%", md:"254px" },
                      height: "56px",
                      borderRadius: { xs: "0.5em", md: "0.5em 0 0 0.5em" },
                      fontSize: "1rem",
                      order: { xs: 2, md: 1 }
                    }}
                    onClick={handleOpen}
                  >
                    <img
                      src={brokeChainIcon}
                      alt="broke chain icon"
                      height="24px"
                      width="24px"
                      style={{ marginRight: "0.5em" }}
                    />
                    Report Issue
                  </Button>

                  <Button
                    variant="contained"
                    color="success"
                    disabled={isLoading}
                    sx={{
                      margin: { xs: "0.5em", md: "0 2px" },
                      width: { xs:"100%", md:"254px" },
                      height: "56px",
                      borderRadius: { xs: "0.5em", md: "0 0.5em 0.5em 0" },
                      fontSize: "1rem",
                      color: "white",
                      order: { xs: 1, md: 2 }
                    }}
                    onClick={handleSubmit}
                  >
                    {isLoading ?
                      <CircularProgress size={24} sx={{ color: "white" }} />
                      :
                      <Fragment>
                        <img
                          src={creditCardIcon}
                          alt="credit card icon"
                          height="24px"
                          width="24px"
                          style={{ marginRight: "0.5em" }}
                        />
                        Complete Job
                      </Fragment>
                    }
                  </Button>
                </div>

              </div>
            </div>

          </div>

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <EscalationModal onClose={handleClose} isLoading={isLoadingEscalation} setIsLoading={setIsLoadingEscalation}></EscalationModal>
            </Box>
          </Modal>
        </Fragment>
      )}

      {!fetchingCurrentJob && !currentJob && <h4>You do not have a job</h4>}

      <SpecialInstructionModal
        open={specialInstructionModalOpen}
        text={currentJob?.specialInstructions || ""}
        handleClose={() => setSpecialInstructionModalOpen(false)
        }
      />

      {/* Modal for add new buying Email */}
      <Modal
        open={Boolean(openAddEmailModal)}
        onClose={() => setOpenAddEmailModal(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <BuyingEmailForm
            title={openAddEmailModal?.title}
            userId={openAddEmailModal?.userId}
            emailId={parseInt(openAddEmailModal?.emailId)}
            onClose={() => setOpenAddEmailModal(null)}
            beeIsEditing={true}
            onSuccess={buyingEmailCreationOnSuccess}
          />
        </Box>
      </Modal>
    </div>
  );
}
